<template>
  <span>
    <v-card color="grey" flat>
    <v-card-text class="pa-8 d-flex align-center">
      <h6>Hello, </h6>&nbsp<h6 style="color: #EE1D23;">{{ userFullName }}</h6>
      <v-spacer/>
      <v-btn fab small text @click="$router.push('/settings')">
        <v-icon color="rgba(0, 0, 0, 0.6)">settings</v-icon>
      </v-btn>
    </v-card-text>
    <v-divider/>
    <v-card-text class="pa-8 d-flex align-center">
      You have message from out suppot.&nbsp <p style="color: #EE1D23">View</p>
    </v-card-text>
  </v-card>
    <v-card color="grey" flat class="mt-6">
    <v-card-text class="pa-8 pb-0 d-flex align-center">
     <h6 class="text-title">It’s time to buy something in US stores!</h6>
    </v-card-text>
  </v-card>
  </span>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {mapGetters} from "vuex";


export default {
  name: "app-drawer",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
    drawWidth: {
      type: [Number, String],
      default: '230',
    },
    value: Boolean,
  },
  data: () => ({
    mini: false,
    menus: null,
    scrollSettings: {
      maxScrollbarLength: 160
    }
  }),
  watch: {
    showDrawer: {
      handler(val) {
        this.drawer = val
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['menu', 'userFullName']),
    active() {
      return views => !!views.find(v => ('/' + v.view) === this.$route.path)
    },
    drawer: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.drawer = !this.drawer;
    });
  },

  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    }
  },
};
</script>

<style lang="stylus">
/*@import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';*/

#appDrawer
  overflow: hidden

  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto

  .logout-button {
    margin: 0;
    width: 100%;
  }

.text-title {
  //styleName: subtitle-1/subtitle-1, medium;
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.0015em;
  text-align: left;

}
</style>
